import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Newspaper,
  Image,
  Users,
  FileText,
  GraduationCap,
  Building2,
  Building,
  Settings,
  LogOut,
  Beaker,
  Award,
  Star,
  UserCheck,
  Mail,
  BookOpen,
  Megaphone
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { logout, user, isAdmin } = useAuth();

  const menuItems = [
    { icon: LayoutDashboard, label: 'لوحة التحكم', path: '/admin/dashboard' },
    { icon: Megaphone, label: 'الإعلانات', path: '/admin/announcements' },
    { icon: Newspaper, label: 'الأخبار والفعاليات', path: '/admin/news' },
    { icon: Image, label: 'معرض الصور', path: '/admin/gallery' },
    { icon: GraduationCap, label: 'البرامج الأكاديمية', path: '/admin/programs' },
    { icon: Building2, label: 'الكليات', path: '/admin/colleges' },
    { icon: Building, label: 'الإدارات والمراكز', path: '/admin/departments' },
    { icon: Users, label: 'أعضاء هيئة التدريس', path: '/admin/faculty' },
    { icon: Beaker, label: 'المعامل', path: '/admin/labs' },
    { icon: Award, label: 'الشهادات والاتفاقيات', path: '/admin/certifications' },
    { icon: Star, label: 'مميزات الجامعة', path: '/admin/features' },
    { icon: BookOpen, label: 'الأبحاث المنشورة', path: '/admin/research' },
    { icon: FileText, label: 'الصفحات', path: '/admin/pages' },
    { icon: UserCheck, label: 'طلبات التسجيل', path: '/admin/registrations' },
    { icon: Mail, label: 'رسائل التواصل', path: '/admin/contacts' },
    { icon: Settings, label: 'الشعار والخلفية', path: '/admin/site-settings' },
    { icon: Settings, label: 'الفوتر والتواصل', path: '/admin/footer-settings' },
    { icon: Settings, label: 'إعدادات عامة', path: '/admin/settings' },
  ];

  return (
    <div className="w-64 bg-[#0F388E] text-white min-h-screen flex flex-col">
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-[#C9A040] rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xl">ج</span>
          </div>
          <div>
            <h2 className="font-bold text-lg">لوحة التحكم</h2>
            <p className="text-xs text-white/70">جامعة ابن النفيس</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
                isActive
                  ? 'bg-[#C9A040] text-white'
                  : 'text-white/70 hover:bg-white/10 hover:text-white'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-white/10">
        <div className="bg-white/10 rounded-lg p-4 mb-4">
          <p className="text-sm text-white/70">مرحباً،</p>
          <p className="font-semibold">{user?.name || user?.full_name || 'مدير النظام'}</p>
          <p className="text-xs text-[#C9A040] mt-1">{user?.role === 'admin' ? 'مدير' : user?.role === 'editor' ? 'محرر' : 'مشاهد'}</p>
        </div>
        <button
          onClick={logout}
          className="flex items-center gap-3 px-4 py-3 rounded-lg text-white/70 hover:bg-red-500/20 hover:text-red-300 transition-colors w-full"
        >
          <LogOut className="w-5 h-5" />
          <span>تسجيل الخروج</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;